import React from "react";
import { Shield, Headphones, BadgeCheck, Clock, CreditCard, Globe } from "lucide-react";
import "./WhyChooseUs.css";

const features = [
  {
    icon: BadgeCheck,
    title: "Best Price Guarantee",
    description:
      "We search hundreds of airlines and compare thousands of fares in real time so you always get the lowest price available. Found it cheaper elsewhere? We'll match it.",
    iconClass: "why-choose-icon-blue",
  },
  {
    icon: Headphones,
    title: "Expert Travel Support",
    description:
      "Our dedicated team of experienced travel agents is on hand every day to answer questions, handle changes, and make sure your journey goes smoothly from start to finish.",
    iconClass: "why-choose-icon-emerald",
  },
  {
    icon: Shield,
    title: "Safe & Secure Booking",
    description:
      "Every booking is protected with industry-standard encryption. Your personal details and payment information are always kept private and fully secure with us.",
    iconClass: "why-choose-icon-violet",
  },
  {
    icon: Clock,
    title: "24/7 Availability",
    description:
      "Travel doesn't stop at 5pm and neither do we. Whether it's a last-minute booking, an urgent change, or a question at midnight — our team is always here for you.",
    iconClass: "why-choose-icon-orange",
  },
  {
    icon: CreditCard,
    title: "Flexible Payment Options",
    description:
      "Pay your way with a range of options including credit/debit cards, bank transfer, and instalment plans. We make it easy to spread the cost of your travel.",
    iconClass: "why-choose-icon-pink",
  },
  {
    icon: Globe,
    title: "Worldwide Coverage",
    description:
      "From short city breaks to long-haul adventures, we cover flights to over 500 destinations across every continent — all bookable in one place with one trusted team.",
    iconClass: "why-choose-icon-cyan",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-section">
      <div className="why-choose-bg" aria-hidden="true">
        <div className="why-choose-bg-blob-1" />
        <div className="why-choose-bg-blob-2" />
      </div>

      <div className="why-choose-inner">
        <div className="why-choose-header">
          <span className="why-choose-badge">Why Us</span>
          <h2 className="why-choose-title">Why Choose SKYSALE PK?</h2>
          <p className="why-choose-subtitle">
            We make travel simple, affordable and stress-free. Here's what sets us apart.
          </p>
        </div>

        <div className="why-choose-grid">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <div key={feature.title} className="why-choose-card">
                <div className={`why-choose-icon-wrap ${feature.iconClass}`}>
                  <Icon />
                </div>
                <h3 className="why-choose-card-title">{feature.title}</h3>
                <p className="why-choose-card-text">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
